import Vue from 'vue';

export default Vue.component('demo-modal', {
  template: require('./template.html'),
  name: 'demo-modal',
  showDemoModal(o) {
    this.$store.dispatch('setGlobalOpenModal', o);
  },
  data() {
    return {
      showDemoModal: false,
    };
  },
  created() {
    this.showDemoModal = true;
  },
});



// WEBPACK FOOTER //
// ./src/live-demo/modal/index.js